import { CoreModule } from '@abp/ng.core';
import { SettingManagementConfigModule } from '@abp/ng.setting-management/config';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsModule } from '@ngxs/store';
import { CommercialUiConfigModule } from '@volo/abp.commercial.ng.ui/config';
import { AccountAdminConfigModule } from '@volo/abp.ng.account/admin/config';
import { AccountPublicConfigModule } from '@volo/abp.ng.account/public/config';
import { AuditLoggingConfigModule } from '@volo/abp.ng.audit-logging/config';
import { IdentityServerConfigModule } from '@volo/abp.ng.identity-server/config';
import { IdentityConfigModule } from '@volo/abp.ng.identity/config';
import { LanguageManagementConfigModule } from '@volo/abp.ng.language-management/config';
import { registerLocale } from '@volo/abp.ng.language-management/locale';
import { SaasConfigModule } from '@volo/abp.ng.saas/config';
import { TextTemplateManagementConfigModule } from '@volo/abp.ng.text-template-management/config';
import { HttpErrorComponent, ThemeLeptonModule } from '@volo/abp.ng.theme.lepton';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_ROUTE_PROVIDER } from './route.provider';
import { MaterialModule } from './shared/material.module';
import { SharedModule } from './shared/shared.module';
import { MatSortModule } from '@angular/material/sort';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIComponent } from './shared/block-ui/block-ui.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationUserComponent } from './warr/common-component/notification-user/notification-user.component';
import { GlobalErrorHandler } from './shared/global-error-handler/global-error-handler';
import { ErrorHandler } from '@angular/core';
import { CustomAuthGuard } from './identity/guards/CustomAuth.Guard';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    MatSortModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    SharedModule,
    CoreModule.forRoot({
      environment,
      registerLocaleFn: registerLocale(),
    }),
    BlockUIModule.forRoot({
      delayStop: 500,
      template: BlockUIComponent
    }),
    ThemeSharedModule.forRoot({
      httpErrorConfig: {
        errorScreen: {
          component: HttpErrorComponent,
          forWhichErrors: [401, 403, 404, 500],
          hideCloseIcon: true,
        },
      },
    }),
    AccountAdminConfigModule.forRoot(),
    // AccountPublicConfigModule.forRoot(),
    IdentityConfigModule.forRoot(),
    // LanguageManagementConfigModule.forRoot(),
    // SaasConfigModule.forRoot(),
    // AuditLoggingConfigModule.forRoot(),
    // IdentityServerConfigModule.forRoot(),
    // TextTemplateManagementConfigModule.forRoot(),
    SettingManagementConfigModule.forRoot(),
    ThemeLeptonModule.forRoot({
      contentAfterRoutes: [NotificationUserComponent],
    }),
    CommercialUiConfigModule.forRoot(),
    NgxsModule.forRoot([]),
    NgbModule,

  ],
  providers: [APP_ROUTE_PROVIDER, { provide: ErrorHandler, useClass: GlobalErrorHandler }
,CustomAuthGuard
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
